<template>
    <div id="engineerOrder">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            
            <el-form-item style="width:150px;margin-bottom:15px">
                <el-select filterable clearable v-model="searchForm.engineerId" placeholder="工程师">
                    <el-option v-for="(item,index) in pickingUserAllList"
                        :label="item.name"
                        :value="item.id"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item style="width:350px;margin-bottom:15px">
                <el-date-picker
                    v-model="valueTime3"
                    type="daterange"
                    range-separator="-"
                    :default-time="['00:00:00', '11:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                </el-col>
            </el-form-item>
        </el-form>
        <el-card class="box-card" style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    label="时间"
                    prop="completeMaintenanceTime">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="工程师"
                    prop="name">
                </el-table-column>
                <el-table-column
                align="center"
                label="gpp"
                prop="gpp">
                </el-table-column>
                <el-table-column  
                align="center"
                label="gpp失败"
                prop="gppLoser">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="strict"
                    label="严选">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="strictLoser"
                    width="200"
                    label="严选失败">
                </el-table-column>
               
                <el-table-column
                    align="center"
                    prop="fetch"
                    label="取机">
                </el-table-column>
                <el-table-column
                    align="center"
                    width="200"
                    label="总数">
                    <template slot-scope="scope">
                        <span>{{scope.row.gpp+scope.row.gppLoser+scope.row.strict+scope.row.strictLoser+scope.row.fetch}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        
    </div>
</template>

<script>
    let moment = require("moment");
    import { applyRefund,checkRefund,getOrderList,engineerOrder} from "../../api/order";
    import { engineerList,selectParameterInfoBusiness } from "../../api/api";
    import {queryUser} from '@/api/api';
    import store from '../../store/store';
    import {genUpToken} from "../basicSetting/com/qiniuToken.js";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'engineerOrder',
        data () {
            return {
                valueTime3:[],
                pickingStatusList:[
                    {
                        paraName:'已完成',
                        paraCode:'14'
                    },
                    {
                        paraName:'退款中',
                        paraCode:'15'
                    },
                    {
                        paraName:'退款完成',
                        paraCode:'16'
                    }
                ],
                pickingUserAllList:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    createTimeStart:'',   //开始时间
                    createTimeEnd:'',     //结束时间
                    engineerId:'',     //收款人
                },
                returnData: [],
                payWayList: [],
                orderIdentifierList:[],
                basicsAuth:{
                    check_refund:false
                }
            }
        },
        mounted () {
            this.basicsAuth.check_refund= getPermission('/api/workOrder/refund/check_refund');
        },
        created(){
            this.getCurDate();
            //this.getOrderPayList();
            //this.getOrderIdentifier();
            this.getEngineerOrder();
            this.queryUserAllList();
        },
        methods: {
           
            //获取昨天日期
            getCurDate(){
                let myDate = new Date();
                myDate.setDate(myDate.getDate() - 1);//设置日期
                let year = myDate.getFullYear();
                let month = (myDate.getMonth()+1) < 10 ? ("0" + (myDate.getMonth()+1)) : (myDate.getMonth() + 1);
                let day = myDate.getDate() < 10 ? ("0" + myDate.getDate()) : myDate.getDate();
                let dayNow = year + '-' + month + "-" + day;
                this.searchForm.createTimeStart = dayNow;
                this.searchForm.createTimeEnd = dayNow;
                let start = dayNow + ' 00:00:00';
                let end = dayNow + " 23:59:59";
                this.valueTime3[0] = new Date(start);
                this.valueTime3[1] = new Date(end);
            },
            //查询所有系统账号
            queryUserAllList(){
                engineerList({startRow:1,pageSize:10000,state:1}).then(res =>{
                    if(res.data.status == '100'){
                        this.pickingUserAllList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.valueTime3 = [];
                this.getEngineerOrder();
            },
            //获取财务利润列表
            getEngineerOrder(){
                
                engineerOrder(this.searchForm).then(res => {
                    if (res.data.status==100) {
                            this.returnData = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getEngineerOrder()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getEngineerOrder()
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        console.log(this.valueTime3)
                        if(this.valueTime3 == null){
                            this.searchForm.createTimeStart = ''
                            this.searchForm.createTimeEnd = ''
                        }else if (this.valueTime3.length == 0) {
                            this.searchForm.createTimeStart = ''
                            this.searchForm.createTimeEnd = ''
                        }else{
                             console.log('时间');
                            this.searchForm.createTimeStart = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                            this.searchForm.createTimeEnd = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                    
                       console.log(this.searchForm.createTimeStart);
                         console.log(this.searchForm.createTimeEnd);
                       }
                        this.getEngineerOrder()
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    .hide-upload{
        .el-upload {
            display: none;
        }
    }
    #financialInterest{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px;
        }
        .active-code{
            color:#409EFF
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }

</style>



// WEBPACK FOOTER //
// engineerOrder.vue?193e746b